<template>
    <v-sheet :class="attachClass" style="position: relative">
        <v-menu ref="menu" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" min-width="290px" max-width="290px" offset-y :attach="attach ? `.${attachClass}` : false">
            <template #activator="{ on }">
                <v-text-field :value="formatData" append-icon="event" readonly v-bind="$attrs" v-on="on" @click:append="on.click" class="pt-0" :class="textFieldClass"></v-text-field>
            </template>
            <v-date-picker v-model="date" type="date" max="2999-12-31" no-title scrollable @input="$refs.menu.save(date)"></v-date-picker>
        </v-menu>
    </v-sheet>
</template>

<script>
export default {
    props: {
        value: { type: String, default: undefined },
        textFieldClass: { type: String, default: "" },
        attach: { type: Boolean, default: false },
    },
    data() {
        return {
            date: this.$props.value,
            attachClass: `v-date-field-activator-${Math.random().toString().slice(2)}`,
        };
    },
    watch: {
        value() {
            this.date = this.value;
        },
        date() {
            this.$emit("input", this.date);
        },
    },
    computed: {
        formatData() {
            return this.date?.substr(0, 10);
        },
    },
};
</script>
